<template>
  <d2-container>
    <el-card class="filter-container" shadow="never">
      <div>
        <i class="el-icon-search"></i>
        <span style="margin-left: 5px">筛选搜索</span>
        <el-button style="float: right; margin-right: 15px" type="primary" @click="handleSearchList" size="small"> 查询搜索 </el-button>
        <el-button style="float: right; margin-right: 15px" @click="handleResetSearch" size="small"> 重置 </el-button>
      </div>
      <div style="margin-top: 15px">
        <el-form :inline="true" :model="listQuery" size="small" label-width="140px">
          <el-form-item label="手机号码:">
            <el-input v-model="listQuery.phone" class="input-width" placeholder="请输入用户手机号码" clearable></el-input>
          </el-form-item>
          <el-form-item label="捐赠类型:">
            <el-select v-model="listQuery.type" placeholder="请选择捐赠类型">
              <el-option label="全部" value=""></el-option>
              <el-option label="个人捐赠" value="1"></el-option>
              <el-option label="团队捐赠" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="操作时间：">
            <el-date-picker
              v-model="listQuery.createTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 350px"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <div class="table-container">

      <el-table ref="orderTable" :data="list" style="width: 100%; margin: 10px 0 15px" v-loading="listLoading" border stripe>
        <el-table-column type="index" label="#" width="80" align="center">
          <template slot-scope="scope">
            {{ scope.$index + 1 + (listQuery.pageNum - 1) * listQuery.pageSize }}
          </template>
        </el-table-column>

        <el-table-column align="center" label="账号">
          <template slot-scope="scope">
            <div v-if="scope.row.phone">{{ scope.row.phone }}</div>
          </template>
        </el-table-column>


        <el-table-column align="center" label="捐赠人信息">
          <template slot-scope="scope">
            <div v-if="scope.row.name">{{ scope.row.name }}</div>
          </template>
        </el-table-column>

        <el-table-column align="center" label="捐赠人头像">
          <template slot-scope="scope">
            <el-image style="width: 100px; height: 100px;  border-radius:50% "  :src="scope.row.icon" :preview-src-list="[scope.row.icon]"> </el-image>
          </template>
        </el-table-column>

         <el-table-column align="center" label="捐赠金额">
          <template slot-scope="scope">
            <div>{{ scope.row.amount }}元</div>
          </template>
        </el-table-column>

        <el-table-column align="center" label="详情清单">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="handleDetail(scope.row)">查看详情</el-button>
          </template>
        </el-table-column>


      </el-table>
    </div>

    <!-- 详情弹窗 -->
    <el-dialog title="详情清单" :visible.sync="detailDialogVisible" width="60%" :close-on-click-modal="false" @close="handleTableClose">
      <div style="padding: 10px">
        <el-form :inline="true" :model="tableQuery" size="small" label-width="120px">
          <el-form-item label="手机号:">
            <el-input  disabled v-model="tableQuery.phone" class="input-width" placeholder="手机号" readonly></el-input>
          </el-form-item>
          <el-form-item label="捐赠类型:">
            <el-select v-model="tableQuery.type" placeholder="请选择捐赠类型">
              <el-option label="全部" value=""></el-option>
              <el-option label="个人捐赠" value="1"></el-option>
              <el-option label="团队捐赠" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="操作时间：">
            <el-date-picker
              v-model="tableQuery.createTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 350px"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="handleTableSearchList">查询</el-button>
            <el-button size="small" @click="handleTableClose">关闭</el-button>
          </el-form-item>
        </el-form>

        <el-table :data="tableList" style="width: 100%; margin-top: 10px" v-loading="tableLoading" border stripe>
          <el-table-column type="index" label="#" width="70" align="center">
            <template slot-scope="scope">
              {{ scope.$index + 1 + (tableQuery.pageNum - 1) * tableQuery.pageSize }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="主题活动">
            <template slot-scope="scope">
              <div v-if="scope.row.theme">{{ scope.row.theme }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="捐赠人类型">
            <template slot-scope="scope">
              <div>{{ scope.row.type | filterType }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="捐赠人名称">
            <template slot-scope="scope">
              <div v-if="scope.row.name">{{ scope.row.name }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="捐赠金额">
            <template slot-scope="scope">
              <div>{{ scope.row.amount }}元</div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="是否匿名">
            <template slot-scope="scope">
              <div>{{ scope.row.ifShow | filterIfShow }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="用户留言">
            <template slot-scope="scope">
              <div v-if="scope.row.remark">{{ scope.row.remark }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="创建时间">
            <template slot-scope="scope">
              <div v-if="scope.row.createTime">{{ scope.row.createTime }}</div>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container">
          <el-pagination
            background
            @size-change="handleTableSizeChange"
            @current-change="handleTableCurrentChange"
            layout="total, sizes,prev, pager, next,jumper"
            :current-page.sync="tableQuery.pageNum"
            :page-size="tableQuery.pageSize"
            :page-sizes="[5, 10, 15, 20, 30, 50]"
            :total="tableTotal"
          >
          </el-pagination>
        </div>
      </div>
    </el-dialog>

    <template slot="footer">
      <div class="pagination-container">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          layout="total, sizes,prev, pager, next,jumper"
          :current-page.sync="listQuery.pageNum"
          :page-size="listQuery.pageSize"
          :page-sizes="[5, 10, 15, 20, 30, 50]"
          :total="total"
        >
        </el-pagination>
      </div>
    </template>

  </d2-container>
</template>

<script>
import { pageRanking as  page  , pageLog } from "@/api/workbench/activity/index"
import TinymceEditor from "@/components/tinymce-editor/tinymce-editor"
import richText from "@/mixins/richText"
import wangeditor from "@/mixins/wangeditor"
import axios from "axios"
const defaultListQuery = {
  pageNum: 1,
  pageSize: 10,
  status: null,
  orderNo:null,
  phone: null,
  type: null,
  createTime: null
}
const defaultListForm = {
  id: null,
  theme: "",
  content: "",
  status: null,
  startTime: null,
  endTime:null,
  ifHot:0,
  shrinkUrl:null,
  hostUrl:null,
  shareText:null,
  sort:null
}
const defaultTableQuery = {
  pageNum: 1,
  pageSize: 10,
  createTime: null,
  phone:null,
  type: null
}
export default {
  name: "orderList",
  components: { TinymceEditor },
  props: { value: Object },
  mixins: [richText, wangeditor],
  data() {
    return {
      rules: {
        theme: [{ required: true, message: "请填写主题", trigger: "blur" }],
        status: [{ required: true, message: "请选择状态", trigger: "blur" }],
        content: [{ required: true, message: "请填写内容", trigger: "blur" }],
        shrinkUrl: [{ required: true, message: "请上传缩略图", trigger: "blur" }],
        shareText: [{ required: true, message: "请填写分享标语", trigger: "blur" }],
        hostUrl: [{ required: true, message: "请上传轮播图", trigger: "blur" }],
        startTime: [{ required: true, message: "请选择开始时间", trigger: "blur" }],
        endTime: [{ required: true, message: "请选择结束时间", trigger: "blur" }],
        ifHot: [{ required: true, message: "请选择是否热门", trigger: "blur" }],
        sort: [{ required: true, message: "请填写排序字段", trigger: "blur" }],
      },
      listQuery: Object.assign({}, defaultListQuery),
      listLoading: true,
      list: null,
      total: null,
      dialogFormVisible: false,
      form: Object.assign({}, defaultListForm),
      status: true,
      fileData: "",
      imageUrl: "",
      statusOptions: [
        { label: "未付款", value: 0 },
        { label: "已付款", value: 1 },
        { label: "已取消", value: 2 },
      ],
      selectProductPics: [],
      ossUploadUrl: process.env.VUE_APP_API + "/tool/oss/upload",
      dialogVisible: false,
      dialogImageUrl: null,
      drawerSync:false,
      detailDialogVisible:false,
      tableQuery: Object.assign({}, defaultTableQuery),
      tableLoading:false,
      tableList:null,
      tableTotal:null,
    }
  },

  activated() {
    this.getList()
  },
  watch: {
    listQuery: {
      handler(val) {
        Object.keys(val).forEach(key => {
          if (!val[key] && val[key] !== 0) val[key] = undefined
        })
      },
      deep: true
    }
  },
  filters: {
    filterType(type) {
      switch (type) {
        case 1:
          return "个人捐赠"
        case 2:
          return "团队捐赠"
        default:
          return "未知"
      }
    },
    filterIfShow(type) {
      switch (type) {
        case 0:
          return "否"
        case 1:
          return "是"
        default:
          return "未知"
      }
    }
  },
  beforeDestroy() {
    const editor = this.editor
    if (editor == null) return
    editor.destroy() // 组件销毁时，及时销毁编辑器
  },
  methods: {
    handleDetail(row){
      this.detailDialogVisible = true
      // 从列表筛选条件复制当前时间范围与类型
      this.tableQuery.createTime = this.listQuery.createTime
      this.tableQuery.type = this.listQuery.type
      // 选择的用户手机号
      this.tableQuery.phone = row.phone
      this.tableQuery.pageNum = 1
      this.getTableList()
    },
    getTableList() {
      this.tableLoading = true
      const { createTime, ...data } = this.tableQuery
      if (createTime && Array.isArray(createTime) && createTime.length === 2) {
        data.startTime = createTime[0]
        data.endTime = createTime[1]
      }
      // 弹窗详情固定只查询已付款/有效记录
      data.status = 1
      pageLog(data).then(response => {
        this.tableLoading = false
        this.tableList = response.rows
        this.tableTotal = response.total
      })
    },
    handleTableSearchList(){
      this.tableQuery.pageNum = 1
      this.getTableList()
    },
    handleTableClose(){
      this.tableQuery=Object.assign({}, defaultTableQuery)
      this.detailDialogVisible = false
    },
    handleStatusChange(index, row) {
      let params = new URLSearchParams()
      params.append("id", row.id)
      params.append("status", row.status)
      statusObj(params).then(response => {
        this.$message.success("修改成功")
        this.getList()
      })
    },
    handleIfHotChange(index, row) {
      let params = new URLSearchParams()
      params.append("id", row.id)
      params.append("ifHot", row.ifHot)
      ifHotObj(params).then(response => {
        this.$message.success("修改成功")
        this.getList()
      })
    },
    handleUploadError() {
      this.$message.error("上传失败")
    },
    handleExceed() {
      this.$message.warning("最多只能上传10张图片")
    },
    handlePreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleUploadSuccess(res) {
      if (this.form.hostUrl) {
         this.form.hostUrl =  this.form.hostUrl + "," + res.data
      } else {
         this.form.hostUrl = res.data
      }
    },
    handleRemove(file, fileList) {
      const urlArr = fileList.map(item => item.url)
      this.form.hostUrl = urlArr + ""
    },
    uploadFile(file) {
      this.fileData = new FormData()
      this.fileData.append("file", file.file)
      axios.post(this.ossUploadUrl, this.fileData, { headers: { "Content-Type": "multipart/form-data" } }).then(res => {
        if (this.form.hostUrl) {
          this.form.hostUrl = this.form.hostUrl + "," + res.data.data
        } else {
          this.form.hostUrl = res.data.data
        }
      })
    },
    //商品相册上传
    beforeUpload(file) {
      const allowType = ["image/jpeg", "image/png"]
      const allowSize = 1024 * 1024 * 10
      if (!allowType.includes(file.type)) {
        this.$message.error("仅支持 JPG 和 PNG 格式!")
        return false
      }
      if (file.size > allowSize) {
        this.$message.error("大小不能超过 10MB!")
        return false
      }
      return true
    },
    getAlbumnPics() {
      if (this.form.hostUrl && this.form.hostUrl.length > 0) {
        const fileList = this.form.hostUrl.split(",")
        this.selectProductPics = fileList.map(item => {
          return { name: "xxx", url: item }
        })
      } else {
        this.selectProductPics = []
      }
    },
    handleTableSearchList(){
      this.tableQuery.pageNum = 1
      this.getTableList()
    },
    onChangeEditor(e) {
      console.log("e", e)
    },
    handleCommentSearchList(){
      this.commentQuery.pageNum = 1
      this.getCommentList()
    },
    handleTableSizeChange(val) {
      this.tableQuery.pageSize = val
      this.getTableList()
    },
    handleCommentSizeChange(val) {
      this.commentQuery.pageSize = val
      this.getCommentList()
    },
    handleTableCurrentChange(val){
      this.tableQuery.pageNum = val
      this.getTableList()
    },
    handleCommentCurrentChange(val){
      this.commentQuery.pageNum = val
      this.getCommentList()
    },
    beforeUploadImg(file) {
      const allowType = ["image/jpeg", "image/png"]
      const allowSize = 1024 * 1024 * 10
      if (!allowType.includes(file.type)) {
        this.$message.error("仅支持 JPG 和 PNG 格式!")
        return false
      }
      if (file.size > allowSize) {
        this.$message.error("大小不能超过 10MB!")
        return false
      }
      return true
    },
    uploadFileImg(file) {
      this.fileData = new FormData()
      this.fileData.append("file", file.file)
      axios.post(this.ossUploadUrl, this.fileData, { headers: { "Content-Type": "multipart/form-data" } }).then(res => {
        this.form.shrinkUrl = res.data.data
      })
    },

    handleExcel() {
      const { createTime, ...data } = this.listQuery
      if (createTime && Array.isArray(createTime) && createTime.length === 2) {
        data.startTime = createTime[0]
        data.endTime = createTime[1]
      }
      axios.post(process.env.VUE_APP_API + "/admin/activity/export", data, { responseType: "blob" }).then(res => {
        if (!res.data) {
          this.$message.warning("无数据")
          return
        }

        if ("msSaveOrOpenBlob" in navigator) {
          window.navigator.msSaveOrOpenBlob(blob, "国兴人捐赠表.xlsx")
        } else {
          const elink = document.createElement("a")
          let blob = new Blob([res.data])
          elink.download = "国兴人捐赠表.xlsx"
          elink.style.display = "none"
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        }
      })
    },

    getUserList() {
      const query = { status: 1, type: 2 }
      list(query).then(response => {
        this.userList = response
      })
    },
    handleSave() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.form.status = this.status ? 1 : 0
          saveOrUpdate(this.form).then(response => {
            this.$message.success("信息更改成功!")
            this.handleClose()
            this.getList()
          })
        } else {
          return false
        }
      })
    },
    handleClose() {
      this.dialogFormVisible = false
    },
    handleAdd() {
      this.status = true
      this.form = Object.assign({}, defaultListForm)
      this.dialogFormVisible = true
    },
    handleUpdate(row) {
      this.dialogFormVisible = true
      this.form = row
      this.getAlbumnPics()
      this.status = this.form.status == 1 ? true : false
    },
    getList() {
      this.listLoading = true
      const { createTime, ...data } = this.listQuery
      if (createTime) {
        data.startTime = createTime[0]
        data.endTime = createTime[1]
      }
      page(data).then(response => {
        this.listLoading = false
        this.list = response.rows
        this.total = response.total
      })
    },

    handleResetSearch() {
      this.listQuery = Object.assign({}, defaultListQuery)
    },
    handleSearchList() {
      this.listQuery.pageNum = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.pageNum = val
      this.getList()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    }
  }
}
</script>

<style lang="scss" scoped>
// 处理副本被其他元素盖住
/deep/ .w-e-full-screen-container {
  z-index: 9999 !important;
}
.drawer {
  /deep/ .el-drawer {
    width: 400px !important;
  }
}
.block {
  margin: 40% 0px;
  /deep/ ul.el-timeline {
    padding: 0px 0px 0px 15px;
  }
}

/deep/ .el-button[data-v-29df88f7] {
     margin-bottom: 0px;
     margin-left: 15px;
}
/deep/ .el-badge__content.is-fixed {
    position: absolute;
    top: 10px;
    right: 10px;
    -webkit-transform: translateY(-50%) translateX(100%);
    transform: translateY(-50%) translateX(100%);
}


.input-width {
  width: 203px;
}
.el-button {
  margin-bottom: 10px;
}
/deep/ .el-dialog__body {
  padding: 0 10px;
}
/deep/ .el-pagination {
    white-space: nowrap;
    padding: 17px 5px;
    color: #303133;
    font-weight: 700;
}
.check-but {
  width: 100%;
  background: #edf2ff;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 4px 0px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
  border: 1px dashed #b0b7c2;
}
.avatar {
  width: 148px;
  height: 148px;
  display: block;
}
.upload-class {
  font-size: 67px;
  color: #c0c4cc;
  margin: 40px 0 16px;
  line-height: 50px;
}
/deep/ .el-table {
    margin-top: 13px;

}
</style>
